export type FlagsType = {
  test: number;
  control: number;
  excluded: number;
};

export type TFeatureFlags = {
  [flagName: string]: {
    flags: FlagsType;
  };
};

/* Signalman Flags */
export const APPLE_PAY_FLAG_NAME = 'apple_pay_v1';
export const AUTH0_ROLLOUT_FLAG_NAME = 'feature_auth0_rollout';
export const PS_CART_REDIRECT_FLAG_NAME = 'ps_cart_invalid_test_v1';
export const PS_CART_REDIRECT_DATESTAMP = '20250123';
export const PS_CART_VALIDATION_FLAG_NAME = 'feature_ps_cart_validation';
export const STICKYCHECKOUT_FLAG_NAME = 'sticky_checkout_button_v1';
export const STICKYCHECKOUT_DATESTAMP = '20250317';
export const VOLUME_DISCOUNT_FLAG_NAME = 'volume_discount_v2';
export const VOLUME_DISCOUNT_DATESTAMP = '20250411';

const FeatureFlags = {
  [APPLE_PAY_FLAG_NAME]: {
    flags: {
      test: 0.1,
      control: 0.1,
      excluded: 0.8,
    },
  },
  add_design_to_more: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1,
    },
  },
  multi_item_voucher: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1,
    },
  },
  embedded_tax_exemptions: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1,
    },
  },
  product_image_enlarge_v1: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0,
    },
  },
  [STICKYCHECKOUT_FLAG_NAME]: {
    flags: {
      test: 0.5,
      control: 0.5,
      excluded: 0,
    },
  },
  embedded_tax_exemptions___custom_styles: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0,
    },
  },
  [VOLUME_DISCOUNT_FLAG_NAME]: {
    flags: {
      test: 0.5,
      control: 0.5,
      excluded: 0,
    },
  },
} as const satisfies TFeatureFlags;

export type FlagName = keyof typeof FeatureFlags;
export type FlagValue = keyof FlagsType;

export default FeatureFlags;
